<script>
	const _ = require('underscore');
	const studentProgressUtilities = require('utilities/studentProgressUtilities');
	const model = require('model/model');
	const analyticsUtilities = require('utilities/analyticsUtilities');
	const classUtilities = require('utilities/classUtilities');
	const utilities = require('utilities');
	const getWordCount = utilities.getWordCount;
	const Grading = require('readworks-grading');
	const logger = require('utilities/logger');

	const sortStudentsByName = classUtilities.sortStudentsByName;

	const fireEvent = analyticsUtilities.fireEvent;
	const INDIVIDUAL_STUDENT_PROGRESS_VIEW = analyticsUtilities.events.INDIVIDUAL_STUDENT_PROGRESS_VIEW;

	const READING_TAB = studentProgressUtilities.gridKeys.READING_TAB;
	const PASSAGES_TAB = studentProgressUtilities.gridKeys.PASSAGES_TAB;
	const VOCAB_TAB = studentProgressUtilities.gridKeys.VOCAB_TAB;
	const PAIREDTEXT_TAB = studentProgressUtilities.gridKeys.PAIREDTEXT_TAB;
	const AAD_TAB = studentProgressUtilities.gridKeys.AAD_TAB;

	let timeout = null;

	module.exports = {
		modelData: {
			studentProgressTab: 'studentProgressTab',
			studentId: 'studentId',
			roster: 'roster',
			studentProgressResults: 'studentProgressResults',
			studentProgressLibraryResults: 'studentProgressLibraryResults',
			studentProgressMonth: 'month',
			classCode: 'classCode'
		},
		props: {
			currentClass: {
				required: true
			},
			exportData: {
				required: false
			},
			printView: {
				required: false
			}
		},
		components: {
			'results-grid': require('components/results-grid.vue').default,
			'tab-container': require('components/tab-container.vue').default,
			'info-icon': require('components/svg/info-icon.vue').default
		},
		data: function () {
			return {
				tabOrder: [READING_TAB, PASSAGES_TAB, VOCAB_TAB, PAIREDTEXT_TAB, AAD_TAB]
			};
		},
		methods: {
			onGridCellClick: function (record, col) {
				if (col.field === 'name') {
					let student = record.uid;
					let classCode = this.classCode;
					let studentId = record.uid;
					let isp = 'isp-progress';
					model.set({
						studentId,
						isp
					});
					fireEvent(INDIVIDUAL_STUDENT_PROGRESS_VIEW, {
						student,
						classCode
					});
				} else if (col.field === 'bokCount') {
					let studentId = record.uid;
					let isp = 'bbok-progress';
					model.set({
						studentId,
						isp
					});
				} else if (col.field === 'library') {
					let studentId = record.uid;
					let isp = 'library-progress';
					model.set({
						studentId,
						isp
					});
				}
			},
			getGridCellDisplayValue: function (record, col) {
				if (col.formatter) {
					return col.formatter.call(this, record[col.field], record, col);
				} else {
					return record[col.field];
				}
			},
			fetchData: function () {
				let classCode = this.classCode;
				let startDate = this.startDate;
				let endDate = this.endDate;

				if (timeout) {
					clearTimeout(timeout);
				}

				timeout = setTimeout(() => {
					studentProgressUtilities.fetchStudentProgressResults(classCode, startDate, endDate).fail(msg => logger.error(msg));
				}, 20);
			}
		},
		watch: {
			classCode: {
				handler: function () {
					this.fetchData();
				},
				immediate: true
			},
			month() {
				this.fetchData();
			},
			resultsData(results) {
				let studentProgressTab = this.studentProgressTab;
				let exportHeader = [];
				let rows = [];
				results = results && results.length ? results : [];

				if (studentProgressTab === READING_TAB) {
					exportHeader = [
						'Students',
						'Nonfiction Passages Read',
						'Nonfiction Words Read',
						'Literary Passages Read',
						'Literary Words Read',
						'Library Passages Read',
						'Total Passages Read',
						'Total Words Read'
					];
					results.forEach(s => {
						rows.push([
							s.firstName + (s.lastName ? ' ' + s.lastName : ''),
							s.nonfiction,
							s.nonfictionWords,
							s.literary,
							s.literaryWords,
							s.library,
							s.total,
							s.totalWords
						]);
					});
				} else if (studentProgressTab === AAD_TAB) {
					exportHeader = ['Students', 'Articles Read', 'Words Read', 'Book of Knowledge Entries Submitted', 'Words Written'];
					results.forEach(s => {
						rows.push([s.firstName + (s.lastName ? ' ' + s.lastName : ''), s.articleCount, s.wordCount, s.bokCount, s.wordsWritten]);
					});
				} else {
					exportHeader = ['Students', 'Question Sets Submitted', 'Question Sets Assigned', 'Correct', 'Graded', '% Correct'];
					results.forEach(s => {
						rows.push([
							s.firstName + (s.lastName ? ' ' + s.lastName : ''),
							s.submitted,
							s.assigned,
							s.correct,
							s.graded,
							studentProgressUtilities.getPercentage(s.correct, s.graded) + '%'
						]);
					});
				}
				model.set('studentProgressExportData', [exportHeader].concat(rows));
			}
		},
		computed: {
			activeTabData() {
				let tab = this.studentProgressTab;
				if (this.STATIC_DATA.tabs[tab]) {
					return this.STATIC_DATA.tabs[tab];
				}
				return {};
			},
			rawResults: function () {
				let results = this.studentProgressResults;
				let classCode = this.classCode;
				let startDate = this.startDate;
				let endDate = this.endDate;

				if (!results || !classCode || !startDate || !endDate) {
					return null;
				}

				return results[classCode + startDate + endDate];
			},
			rawLibraryResults: function () {
				let results = this.studentProgressLibraryResults;
				let classCode = this.classCode;
				let startDate = this.startDate;
				let endDate = this.endDate;

				if (!results || !classCode || !startDate || !endDate) {
					return null;
				}

				return results[classCode + startDate + endDate];
			},
			startDate: function () {
				let month = this.month;
				return studentProgressUtilities.getStartDate(month);
			},
			endDate: function () {
				let month = this.month;
				let endDate = studentProgressUtilities.getEndDate(month);
				let now = new Date().getTime();

				if (endDate > now) {
					endDate = now;
				}

				return endDate;
			},
			monthList: function () {
				let currentClass = this.currentClass;
				let createdTS = 0;
				let monthList = [];

				if (currentClass && currentClass.created) {
					createdTS = currentClass.created * 1000;
				}
				if (typeof createdTS === 'number' && currentClass) {
					monthList = studentProgressUtilities.getMonthList(createdTS);
				}

				monthList.push({
					text: 'See All',
					value: 'all'
				});

				return monthList;
			},
			rosterById: function () {
				let roster = this.roster;
				let classCode = this.classCode;
				if (roster && classCode && roster[classCode]) {
					return roster[classCode].studentsById;
				}
				return null;
			},
			resultsData: function () {
				const rawResults = this.rawResults;
				const rawLibraryResults = this.rawLibraryResults;
				const rosterById = this.rosterById;

				var results = {},
					self = this;

				if (rosterById) {
					for (let studentUid in rosterById) {
						let student = rosterById[studentUid];
						let total = 0;
						let totalWords = 0;
						let library = 0;
						let libraryWords = 0;

						if (rawLibraryResults) {
							let libraryResults = rawLibraryResults[studentUid];

							if (libraryResults && libraryResults.length) {
								library = libraryResults.length;
								libraryWords = libraryResults.reduce((acc, entry) => {
									if (entry && entry.wc) {
										acc += entry.wc;
									}
									return acc;
								}, 0);
								total += library;
								totalWords += libraryWords;
							}
						}

						results[studentUid] = {
							firstName: student.firstName,
							lastName: student.lastName,
							uid: studentUid,
							nonfiction: 0,
							nonfictionWords: 0,
							literary: 0,
							literaryWords: 0,
							articleCount: 0,
							wordCount: 0,
							bokCount: 0,
							wordsWritten: 0,
							submitted: 0,
							correct: 0,
							graded: 0,
							assigned: 0,
							wordsExplored: 0,
							library,
							libraryWords,
							total,
							totalWords
						};
					}
				} else {
					return null;
				}

				if (rawResults) {
					if (this.studentProgressTab === READING_TAB) {
						rawResults.forEach(result => {
							var product = result.product;

							if (product.pt === 'AAD') {
								// If AAD, articles are "read" individually before a workspace is submitted
								let countsByArticle = {};

								const allArticles = product.allArticles;

								for (let uuid in allArticles) {
									let article = allArticles[uuid];
									let countsForArticle = (countsByArticle[uuid] = {
										nonfiction: 0,
										nonfictionWords: 0,
										literary: 0,
										literaryWords: 0
									});
									let textTypes = article.t || product.t || [];

									textTypes.forEach(function (textType) {
										if (textType === 12) {
											countsForArticle.nonfiction++;
											countsForArticle.nonfictionWords += article.wordcount || 0;
										} else if (textType === 13 || textType === 191969) {
											countsForArticle.literary++;
											countsForArticle.literaryWords += article.wordcount || 0;
										}
									});
								}

								const suids = result.suids;

								result.workspaces.forEach(workspace => {
									const studentId = workspace.uid;
									const isInClass = this.currentClass.roster.includes(studentId);
									const isAssigned = suids && (!Object.keys(suids).length || suids[studentId]);
									const fullySubmitted = workspace.s === 's';

									if (isInClass && (isAssigned || fullySubmitted)) {
										for (let uuid in workspace.sc.a) {
											var workspaceDataForArticle = workspace.sc.a[uuid];

											if (workspaceDataForArticle.s === 's') {
												let studentUid = workspace.uid;
												let stats = results[studentUid];
												if (stats) {
													let countsForArticle = countsByArticle[uuid];

													stats.nonfiction += countsForArticle.nonfiction;
													stats.nonfictionWords += countsForArticle.nonfictionWords;
													stats.literary += countsForArticle.literary;
													stats.literaryWords += countsForArticle.literaryWords;
													stats.total += countsForArticle.nonfiction + countsForArticle.literary;
													stats.totalWords += countsForArticle.nonfictionWords + countsForArticle.literaryWords;
												}
											}
										}
									}
								});
							} else {
								// If not AAD, articles are "read" when the workspace is submitted
								var nonfiction = 0,
									nonfictionWords = 0,
									literary = 0,
									literaryWords = 0;

								if (product.pt === 'P') {
									for (let uuid in product.articles) {
										let article = product.articles[uuid];
										let textTypes = article.t || product.t || [];

										textTypes.forEach(function (textType) {
											if (textType === 12) {
												nonfiction++;
												nonfictionWords += article.wordcount || 0;
											} else if (textType === 13 || textType === 191969) {
												literary++;
												literaryWords += article.wordcount || 0;
											}
										});
									}
								} else {
									// This is ok for StepReads, we don't want counts to include each individual SR
									let textTypes = product.t || [];
									textTypes.forEach(function (textType) {
										if (textType === 12) {
											nonfiction++;
											nonfictionWords += product.wordcount || 0;
										} else if (textType === 13 || textType === 191969) {
											literary++;
											literaryWords += product.wordcount || 0;
										}
									});
								}

								result.workspaces.forEach(function (workspace) {
									if (workspace.s === 's') {
										var studentUid = workspace.uid;
										let stats = results[studentUid];
										if (stats) {
											stats.nonfiction += nonfiction;
											stats.nonfictionWords += nonfictionWords;
											stats.literary += literary;
											stats.literaryWords += literaryWords;
											stats.total += nonfiction + literary;
											stats.totalWords += nonfictionWords + literaryWords;
										}
									}
								});
							}
						});
					} else if (this.studentProgressTab === AAD_TAB) {
						rawResults.forEach(result => {
							var product = result.product;

							if (product.pt === 'AAD') {
								const suids = result.suids;

								result.workspaces.forEach(workspace => {
									const studentId = workspace.uid;
									const isInClass = this.currentClass.roster.includes(studentId);
									const isAssigned = suids && (!Object.keys(suids).length || suids[studentId]);
									const fullySubmitted = workspace.s === 's';

									if (isInClass && (isAssigned || fullySubmitted)) {
										for (let uuid in workspace.sc.a) {
											var workspaceDataForArticle = workspace.sc.a[uuid];

											if (workspaceDataForArticle.s === 's') {
												var studentUid = workspace.uid;
												let stats = results[studentUid];
												if (stats) {
													stats.articleCount += 1;
													stats.wordCount += product.allArticles[uuid].wordcount || 0;

													if ('b' in workspaceDataForArticle) {
														stats.bokCount += 1;
														stats.wordsWritten += getWordCount(workspaceDataForArticle.b);
														if ('brev' in workspaceDataForArticle) {
															stats.wordsWritten += getWordCount(workspaceDataForArticle.brev);
														}
													} else if ('brev' in workspaceDataForArticle) {
														stats.bokCount += 1;
														stats.wordsWritten += getWordCount(workspaceDataForArticle.brev);
													}
												}
											}
										}
									}
								});
								if (result.graphicOrganizers && result.graphicOrganizers.length) {
									result.graphicOrganizers.forEach(g => {
										let stats = results[g.uid];
										if (stats && typeof stats.wordsExplored === 'number' && g.n) {
											stats.wordsExplored += Object.keys(g.n).length - 1;
										}
									});
								}
							}
						});
					} else {
						let selectedQuestionSets = this.STATIC_DATA.QUESTION_TAB_TO_SET_NAME[this.studentProgressTab];
						let totalQuestionSets = 0;
						let suids = {};

						if (!(selectedQuestionSets instanceof Array)) {
							selectedQuestionSets = [selectedQuestionSets];
						}

						rawResults.forEach(result => {
							let closed = result.closed;
							let questionSetsForAssignment = result.qs;
							let questionSetIdsToPluck = [];
							suids = Object.keys(result.suids);

							questionSetsForAssignment.forEach(questionSetId => {
								let questionSetName = result.product.questionSets[questionSetId].title;
								let questionSetMatches =
									result.product.pt === 'P' ? this.studentProgressTab === PAIREDTEXT_TAB : selectedQuestionSets.includes(questionSetName);

								if (!questionSetMatches) {
									// No exact match for question set name in QUESTION_TAB_TO_SET_NAME, check for regular expressions
									for (var i = 0, l = selectedQuestionSets.length; i < l; i++) {
										if (selectedQuestionSets[i] instanceof RegExp && selectedQuestionSets[i].test(questionSetName)) {
											questionSetMatches = true;

											break;
										}
									}
								}

								if (questionSetMatches) {
									questionSetIdsToPluck.push(questionSetId);
								}
							});

							if (!suids.length) {
								// For whole class assignments
								totalQuestionSets += questionSetIdsToPluck.length;
							} else if (questionSetIdsToPluck.length) {
								// For specific student assignments
								// AND we're looking at a relevant question set
								suids.forEach(suid => {
									if (results[suid]) {
										results[suid].assigned += questionSetIdsToPluck.length;
									}
								});
							}

							result.workspaces.forEach(function (workspace) {
								if (self.currentClass.roster.indexOf(workspace.uid) !== -1) {
									let studentUid = workspace.uid;
									let stats = results[studentUid];

									if (stats) {
										questionSetIdsToPluck.forEach(function (qsId) {
											let abridgedIds = result.product.questionSets[qsId] && result.product.questionSets[qsId].abridged_question_ids;
											let isExpressQs = abridgedIds && abridgedIds.length > 0 && _.contains(result.expressqs || [], qsId);
											let expressQMap = {};
											if (isExpressQs) {
												expressQMap = abridgedIds.reduce((acc, qid) => {
													acc[qid] = true;
													return acc;
												}, {});
											}
											let workspaceQuestionSetData = workspace.sc.q[qsId];

											if (workspaceQuestionSetData) {
												// Only tally submitted if workspace is marked submitted
												if (workspace.s === 's' || closed) {
													stats.submitted += 1;

													for (let questionId in workspaceQuestionSetData) {
														let workspaceQuestionData = workspaceQuestionSetData[questionId];

														if ((isExpressQs && expressQMap[questionId]) || !isExpressQs) {
															if ('s' in workspaceQuestionData || Grading.questionTypeIsScorable(workspaceQuestionData.qt)) {
																stats.correct += workspaceQuestionData.s || 0;
																stats.graded += 1;
															}
														}
													}
												}
											}
										});
									}
								}
							});
						});

						for (let student in results) {
							let record = results[student];
							// record.submitted = record.submitted + ' / ' + totalQuestionSets;
							record.assigned += totalQuestionSets;
						}
					}
				}

				let sortedResults = [];
				for (let studentKey in results) {
					sortedResults.push(results[studentKey]);
				}
				sortedResults.sort(sortStudentsByName);

				return sortedResults;
			}
		},
		mounted() {
			this.month = this.month || this.currentMonth;
		},
		beforeCreate() {
			// Attached in init because it doesn't need to be reactive
			this.STATIC_DATA = {
				QUESTION_TAB_TO_SET_NAME: studentProgressUtilities.QUESTION_TAB_TO_SET_NAME,
				tabs: studentProgressUtilities.grids
			};

			this.currentMonth = studentProgressUtilities.getCurrentMonth();
		}
	};
</script>
<style lang="scss">
	@import 'config/colors';

	.main.student-progress {
		.table.results-grid {
			.link-cell {
				color: $c-blue;
				cursor: pointer;

				&:hover {
					text-decoration: underline;
				}
			}

			.input-select {
				margin-bottom: 0rem;
				margin-left: 1rem;
				min-width: 7.5rem;
			}

			img.small-icon {
				margin-left: 1rem;
			}
		}
	}
</style>
<template>
	<main class="main student-progress form">
		<tab-container
			variant="pill-tabs"
			:default-tab="tabOrder[0]"
			model-key="studentProgressTab">
			<button
				v-for="tab in tabOrder"
				:key="tab"
				v-if="STATIC_DATA.tabs[tab] && !STATIC_DATA.tabs[tab].hidden"
				:data-tab="tab"
				:class="{
					'print-hidden': studentProgressTab !== tab,
					active: studentProgressTab === tab
				}">
				{{ STATIC_DATA.tabs[tab].title }}
			</button>
		</tab-container>
		<div
			v-if="classCode"
			class="grid-tools margin-bottom-small">
			<div class="input-select slim print-hidden">
				<select
					v-model="month"
					class="input"
					aria-label="Show results for">
					<option
						v-for="month in monthList"
						:key="month.value"
						:value="month.value">
						{{ month.text }}
					</option>
				</select>
			</div>
			<button
				class="button -small blue-outline print-progress"
				v-if="printView"
				@click="printView"
				aria-label="Print">
				<i class="fa-solid fa-print fa-lg"></i>
			</button>
			<button
				class="button -small blue-outline export-progress"
				v-if="exportData"
				@click="exportData"
				aria-label="Export progress">
				<i class="fa-solid fa-up-right-from-square fa-lg"></i>
			</button>
		</div>
		<results-grid
			v-if="classCode"
			:columns="activeTabData.columns"
			:data="resultsData"
			:on-grid-cell-click="onGridCellClick"
			ref="studentProgressTabPanel"
			:data-panel="studentProgressTab">
			<!-- template slot to add month picker -->
			<template slot="thead">
				<div class="tr thead">
					<div
						class="cell"
						v-for="col in activeTabData.columns"
						:key="col.field"
						:style="{ flex: col.flex }"
						:class="[col.textAlign ? col.textAlign + '-text' : '']">
						<div class="cell-wrapper">
							<span v-html="col.text"></span>
							<button
								v-if="col.field === 'correct'"
								class="button -link margin-left-xs print-hidden"
								v-tooltip="'This includes results for all multiple choice and any graded written response questions.'">
								<info-icon></info-icon>
							</button>
						</div>
					</div>
				</div>
			</template>
		</results-grid>
		<div v-if="!classCode">Please ensure you have selected a class in the upper right hand corner.</div>
	</main>
</template>
